// Receives a text from formbuilder formfield default value, or translation ('greet-values')
export function getGreetValues(greetText: string) {
  return greetText.split(',').map((el) => {
    return { name: el.trim(), value: el.trim() };
  });
}
